'use client';

import React from 'react';
import Image from 'next/image';

const useCases = [
  {
    title: "Per l'Avvocato",
    description:
      'Trova in pochi secondi norme, sentenze e precedenti rilevanti. Formula pareri completi e motivati riducendo i tempi di ricerca e redazione.',
    image: '/images/use-cases/legals.webp',
  },
  {
    title: 'Per il Commercialista e CAF',
    description:
      'Gestisci con sicurezza la compliance fiscale e societaria, offrendo ai clienti risposte immediate basate su fonti ufficiali e aggiornate.',
    image: '/images/use-cases/accountants.webp',
  },
  {
    title: 'Per il Consulente del Lavoro',
    description:
      'Affronta con precisione ogni tema di diritto del lavoro e previdenza. Ottieni riferimenti normativi e interpretazioni già pronte per la pratica quotidiana.',
    image: '/images/use-cases/consultants.webp',
  },
  {
    title: "Per l'Azienda: CFO e responsabili amministrativi",
    description:
      'Prendi decisioni strategiche basate su analisi normative e fiscali affidabili. Riduci rischi e garantisci la conformità dell’azienda senza rallentare i processi.',
    image: '/images/use-cases/companies.webp',
  },
];

const UseCasesSection = () => {
  return (
    <section id="useCases" className="py-16 px-4 md:px-8 bg-white scroll-mt-12">
      <div className="max-w-xl md:max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-primary mb-6 font-funnel">
          Soluzioni <span className="text-accent">su misura</span> per ogni professione legale e
          fiscale
        </h2>
        <p className="text-lg text-neutral-700 mb-12">
          Dalla difesa legale alla gestione fiscale e alla compliance aziendale, Trovanorma conosce
          le tue sfide e ti offre strumenti specifici per affrontarle.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 text-left">
          {useCases.map((useCase, i) => (
            <UseCaseCard
              key={i}
              title={useCase.title}
              description={useCase.description}
              image={useCase.image}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

interface UseCaseCardProps {
  title: string;
  description: string;
  image: string;
}

const UseCaseCard = ({ title, description, image }: UseCaseCardProps) => {
  return (
    <div className="rounded-xl bg-white shadow-md space-x-4 hover:shadow-lg transition duration-200 border-1 border-neutral-200">
      <Image
        src={image}
        alt={title}
        width={900}
        height={440}
        className="rounded-t-xl object-contain mx-0 my-0"
      />
      <div className="p-6">
        <h3 className="text-xl font-semibold mb-2">{title}</h3>
        <p className="text-gray-600">{description}</p>
      </div>
    </div>
  );
};

export default UseCasesSection;
